var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{style:({ color: _vm.current.color }),attrs:{"type":"text","disabled":_vm.occupationAuthStatus == 0},on:{"click":_vm.showDetail}},[_vm._v("\n  "+_vm._s(_vm.current.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }